<!-- START OF FOOTER -->
<footer class="site-footer white-text">
    <div class="top-footer">
        <div class="banner-shape">
            <span class="stripe"></span>
            <span class="stripe stripe-secondary"></span>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-lg-3">
                    <div class="footer-left">
                        <div class="footer-branding">
                            <a routerLink="/" title="Goldol">
                                <img src="assets/img/goldol-logo.png" class="goldol-header-logo" alt="Goldol Logo">
                            </a>
                            <p>Lubricant Manufacturers</p>
                        </div>
                        <div class="footer-socials">
                            <ul>
                                <li>
                                    <a href="https://www.facebook.com/" title="Follow on Facebook" target="_blank">
                                        <i class="fab fa-facebook-f"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/" title="Follow on Instagram" target="_blank">
                                        <i class="fab fa-instagram"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.linkedin.com/" title="Follow on Linkedin" target="_blank">
                                        <i class="fab fa-linkedin-in"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://x.com/" title="Follow on Twitter" target="_blank">
                                        <i class="fab fa-twitter"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://x.com/" title="Subscribe on Youtube" target="_blank">
                                        <i class="fab fa-youtube"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2 col-sm-6">
                    <div class="footer-links">
                        <h4 class="h4-title">Our Links</h4>
                        <ul>
                            <li [class.active-footer-menu]="isActive('/')">
                                <a routerLink="/" title="Home">Home</a>
                            </li>
                            <li [class.active-footer-menu]="isActive('/about')">
                                <a routerLink="/about" title="About Us">About Us</a>
                            </li>
                            <li [class.active-footer-menu]="isActive('/products')">
                                <a routerLink="/products" title="Services">Products</a>
                            </li>
                            <li [class.active-footer-menu]="isActive('/careers')">
                                <a routerLink="/careers" title="Services">Careers</a>
                            </li>
                            <li [class.active-footer-menu]="isActive('/faq')">
                                <a routerLink="/faq" title="Services">Faq</a>
                            </li>
                            <li [class.active-footer-menu]="isActive('/contact')">
                                <a routerLink="/contact" title="Contact Us">Contact Us</a>
                            </li>
                            <li>
                                <a href="assets/catalogue/catalogue.pdf" target="_blank" title="Catalogue">Catalogue</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-4 col-sm-6">
                    <div class="footer-links">
                        <h4 class="h4-title">Our Products</h4>
                        <ul>
                            <li [class.active-footer-menu]="isActive('/product-details/goldol-5w30-10000sn-synthetic-engine-oil-uae')">
                                <a routerLink="/product-details/goldol-5w30-10000sn-synthetic-engine-oil-uae" title="GOLDOL 5W30 10000SN Synthetic Engine Oil">GOLDOL 5W30 10000SN Synthetic Engine Oil</a>
                            </li>
                            <li [class.active-footer-menu]="isActive('/product-details/goldol-10w-40-semi-synthetic-engine-oil-uae')">
                                <a routerLink="/product-details/goldol-10w-40-semi-synthetic-engine-oil-uae" title="GOLDOL 10W40 Semi Synthetic Engine Oil">GOLDOL 10W40 Semi Synthetic Engine Oil</a>
                            </li>
                            <li [class.active-footer-menu]="isActive('/product-details/goldol-20w50-5000SL-engine-oil-dubai-uae')">
                                <a routerLink="/product-details/goldol-20w50-5000SL-engine-oil-dubai-uae" title="GOLDOL 20W50 5000SL Engine Oil">GOLDOL 20W50 5000SL Engine Oil</a>
                            </li>
                            <li [class.active-footer-menu]="isActive('/product-details/goldol-super-toyota-engine-oil-5w30-uae')">
                                <a routerLink="/product-details/goldol-super-toyota-engine-oil-5w30-uae" title="GOLDOL Super Toyota Engine Oil 5W30">GOLDOL Super Toyota Engine Oil 5W30</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6">
                    <div class="footer-contact">
                        <h4 class="h4-title">Contact Us</h4>
                        <ul>
                            <li>
                                <div class="contact-item">
                                    <span class="contact-icon">
                                        <i class="fas fa-map-marker-alt"></i>
                                    </span>
                                    <div class="contact-link">
                                        <a href="https://maps.app.goo.gl/BWyoU2MVUnQa7JEf7"
                                            title="Al Sajaa industrial area, Near Cement factory, Sharjah, UAE"
                                            target="_blank">Al Sajaa industrial area, Near Cement factory, Sharjah,
                                            UAE</a>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="contact-item">
                                    <span class="contact-icon">
                                        <i class="fas fa-envelope"></i>
                                    </span>
                                    <div class="contact-link">
                                        <a href="mailto:goldendropoilind@gmail.com "
                                            title="Mail to goldendropoilind@gmail.com ">
                                            goldendropoilind&#64;gmail.com
                                        </a>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="contact-item">
                                    <span class="contact-icon">
                                        <i class="fas fa-phone-alt"></i>
                                    </span>
                                    <div class="contact-link">
                                        <a href="tel:+971581292000" title="Call to +971 58 129 2000">
                                            +971 58 129 2000
                                        </a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="bottom-footer">
        <div class="container">
            <div class="bottom-footer-content">
                <p class="bottom-footer-text m-0">
                    Copyright © <span id="copy-right-year">2025</span> Goldol, All rights reserved.
                </p>
                <ul>
                    <li>
                        <a routerLink="/privacy-policy" title="Privacy Policy">Privacy Policy</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</footer>